import { useState } from 'react'
import { MobileTitle, SystemTitle, Title } from '../../components/Title'
import { SystemBaiscs } from './SystemBasics'
import { Confine } from './Confine'
import { Confriend } from './Confriend'
import { Confire, Gadgets } from './Confire'
import { BaseSystem } from './BaseSystem'
import { PlayItYourWay } from './PlayItYourWay'
import { BattleFlow } from './BattleFlow'
import { Facilities } from './facilities/Facilities'

export const System = () => {
    const [activeSystem, setActiveSystem] = useState('battle')
    const [activeSubSystem, setActiveSubSystem] = useState('systembasics')

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }
    const SystemNav = () => {
        return (
            <div className='flex flex-wrap [&>button]:w-[47%] [&>button]:md:w-[24%] [&>button]:max-w-[280px] justify-evenly pt-20 md:pt-0 md:mt-20 items-start'>
                <button>
                    <span className='relative inline-block '>
                        <img
                            onClick={() => {
                                setActiveSystem('battle')
                                scrollToTop()
                            }}
                            className={`${
                                activeSystem === 'battle' && 'brightness-150'
                            } hover:brightness-150 duration-300`}
                            src={`${process.env.PUBLIC_URL}/images/system/header-battle-system.png`}
                            alt='battle system'
                        />{' '}
                    </span>
                </button>{' '}
                <button>
                    <img
                        onClick={() => {
                            setActiveSystem('battleflow')
                            scrollToTop()
                        }}
                        className={`${
                            activeSystem === 'battleflow' && 'brightness-150'
                        } hover:brightness-150 duration-300`}
                        src={`${process.env.PUBLIC_URL}/images/system/header-battleflow.webp`}
                        alt='battle system'
                    />{' '}
                </button>{' '}
                <button>
                    <img
                        onClick={() => {
                            setActiveSystem('play')
                            scrollToTop()
                        }}
                        className={`${activeSystem === 'play' && 'brightness-150'} hover:brightness-150 duration-300`}
                        src={`${process.env.PUBLIC_URL}/images/system/header-playityourway-system.webp`}
                        alt='play-it-your-way system'
                    />{' '}
                </button>{' '}
                <button>
                    <span className='relative inline-block '>
                        <img
                            onClick={() => {
                                setActiveSystem('facilities')
                                scrollToTop()
                            }}
                            className={`${
                                activeSystem === 'facilities' && 'brightness-150'
                            } hover:brightness-150 duration-300`}
                            src={`${process.env.PUBLIC_URL}/images/system/header-facilities.webp`}
                            alt='facilities system'
                        />
                    </span>
                </button>{' '}
            </div>
        )
    }
    const SystemNavSub = () => {
        return (
            <nav className='mx-auto my-8'>
                <ul className='[&>li>img]:mx-auto [&>li>img]:w-full  [&>li]:w-[47%] [&>li]:md:w-[22%] [&>li]:max-w-[260px] cursor-pointer flex justify-center gap-4 flex-wrap mx-auto px-4 md:px-0 max-w-[1200px] items-end'>
                    <li>
                        <img
                            onClick={() => {
                                setActiveSubSystem('systembasics')
                                scrollToTop()
                            }}
                            className={` ${
                                activeSubSystem === 'systembasics' && 'brightness-125'
                            }  mx-auto hover:brightness-125 duration-300`}
                            alt='system basics'
                            src={`${process.env.PUBLIC_URL}/images/system/header-systembasics-system.webp`}
                        />
                    </li>
                    <li>
                        <img
                            onClick={() => {
                                setActiveSubSystem('confine')
                                scrollToTop()
                            }}
                            className={` ${
                                activeSubSystem === 'confine' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='confire'
                            src={`${process.env.PUBLIC_URL}/images/system/header-confine-new-system.webp`}
                        />
                    </li>
                    <li className='relative inline-block '>
                        <img
                            onClick={() => {
                                setActiveSubSystem('confriend')
                                scrollToTop()
                            }}
                            className={` ${
                                activeSubSystem === 'confriend' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='confriend'
                            src={`${process.env.PUBLIC_URL}/images/system/header-confriend-new-system.webp`}
                        />{' '}
                    </li>{' '}
                    <li>
                        {' '}
                        <img
                            onClick={() => {
                                setActiveSubSystem('confire')
                                scrollToTop()
                            }}
                            className={` ${
                                activeSubSystem === 'confire' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='confire'
                            src={`${process.env.PUBLIC_URL}/images/system/header-confire-new-system.webp`}
                        />
                    </li>
                </ul>
            </nav>
        )
    }
    return (
        <>
            <div className='max-w-[1200px] mx-auto'>
                <div className='py-12 w-full text-center mx-auto'>
                    <span className='relative pt-2'>
                        <h1 className='md:hidden text-gradient-title text-xlg font-pop inline-block'>System</h1>{' '}
                    </span>
                </div>
                <SystemNav />
                {activeSystem === 'facilities' ? (
                    <Facilities />
                ) : activeSystem === 'play' ? (
                    <PlayItYourWay />
                ) : activeSystem === 'battleflow' ? (
                    <BattleFlow />
                ) : (
                    <>
                        <SystemNavSub />
                        <div className='max-w-[1200px] mx-auto my-12 md:my-20'>
                            {(() => {
                                switch (activeSubSystem) {
                                    case 'systembasics':
                                        return <SystemBaiscs />
                                    case 'confine':
                                        return <Confine />
                                    case 'confriend':
                                        return <Confriend />
                                    case 'confire':
                                        return <Confire />
                                    case 'play':
                                        return <PlayItYourWay />

                                    default:
                                        return null
                                }
                            })()}
                        </div>

                        <SystemNavSub />
                    </>
                )}
                <div className='pb-20'>
                    <SystemNav />{' '}
                </div>
            </div>
        </>
    )
}
